import Vue from 'vue'
import Vuex from 'vuex'

import navigation from './modules/navigation'
import main from './modules/main'
import positions from './modules/positions'
import advantages from './modules/advantages'
import proprietary from './modules/proprietary'
import forms from './modules/forms'
import logos from './modules/logos'
import clients from './modules/clients'
import how from './modules/how'
import partners from './modules/partners'
import dic from '@/assets/dictionary/index'
import { LANG } from '@/libs/constants'

const { metaTags } = dic[LANG]

Vue.use(Vuex)

import Url from 'url-parse'

export default new Vuex.Store({
  state: {
    metasConf: {
      default: {
        keywords: metaTags.metaKeywords,
        title: metaTags.metaTitle,
        description: metaTags.metaDecription,
        script: 'default script',
      },
      thankyou: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyouTitle,
        description: metaTags.metaDecription,
        script: 'thankyou1 script',
      },
      thankyou2: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyou2Title,
        description: metaTags.metaDecription,
        script: 'thankyou2 script',
      },
      thankyou3: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyou3Title,
        description: metaTags.metaDecription,
        script: 'thankyou3 script',
      },
      thankyou4: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyou4Title,
        description: metaTags.metaDecription,
        script: 'thankyou4 script',
      },
      thankyou5: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyou5Title,
        description: metaTags.metaDecription,
        script: 'thankyou5 script',
      },
      thankyou6: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyou6Title,
        description: metaTags.metaDecription,
        script: 'thankyou6 script',
      },
      ettn: {
        keywords: metaTags.metaKeywords,
        title: metaTags.thankyouTitle,
        description: metaTags.metaDecription,
      },
      ttn: {
        decription: metaTags.ttnDescription,
        keywords: metaTags.ttnKeywords,
        title: metaTags.ttnTitle,
      },
    },
  },
  mutations: {
    changeLang(state, val) {
      state.main.currentLang = val
    },
    changeDic(state, obj) {
      state.main.dic = obj
    },
    changeMainMassage(state, obj) {
      state.main.messages = obj
    },
    changeAdvantagesData(state, arr) {
      state.advantages.data = [...arr]
    },
    changeClients(state, arr) {
      state.clients.clients = [...arr]
    },
    changeFormsTabs(state, arr) {
      state.forms.tabs = [...arr]
    },
    changeHowExplonation(state, arr) {
      state.how.explonations = [...arr]
    },
    changeNavigationLinks(state, arr) {
      state.navigation.links = [...arr]
    },
    changePartners(state, arr) {
      state.partners.partners = [...arr]
    },
    changePositionList(state, arr) {
      state.positions.positionList = [...arr]
    },
    changeProprietaryAddress(state, arr) {
      state.proprietary.address = [...arr]
    },
  },
  actions: {
    INIT: function(ctx) {
      const { query } = new Url(window.location.href, true)
      const entries = Object.keys(query)
      const { metasConf } = ctx.state

      var currMetaConf = null

      const title = document.getElementsByTagName('title')[0]
      const metas = document.getElementsByTagName('meta')
      const analiticScript = document.createElement('script')

      for (const entry of entries) {
        if (entry in metasConf) {
          currMetaConf = metasConf[entry]
        }
      }

      if (!currMetaConf) currMetaConf = metasConf.default

      title.innerHTML = currMetaConf.title
      analiticScript.type = 'text/javascript'
      analiticScript.async = ''
      analiticScript.src = currMetaConf.script
      document.head.appendChild(analiticScript)

      for (let i = 0; i < metas.length; i++) {
        const currMeta = metas[i]
        const currMetaName = metas[i].getAttribute('name')
        const isValidName =
          currMetaName == 'keywords' ||
          currMetaName == 'title' ||
          currMetaName == 'description'

        if (isValidName) {
          currMeta.setAttribute('content', currMetaConf[currMetaName])
        }
      }
    },
  },
  modules: {
    navigation,
    main,
    positions,
    advantages,
    proprietary,
    forms,
    logos,
    clients,
    how,
    partners,
  },
})
